<template>
  <div class="component-wrapper">
    <div class="form-wrapper">
      <!-- <div>
        <p>{{ userToManage }}</p>
      </div> -->
      <div>
        <label for="districtCode">District Code: </label>
        <input type="text" id="districtCode" v-model="districtCode" disabled>
      </div>
      <!-- <div>
        <label for="districtName">District Name: </label>
        <input type="text" id="districtName" v-model="districtName">
      </div>
      <div>
        <label for="districtCity">District City: </label>
        <input type="text" id="districtCity" v-model="districtCity">
        <label for="districtState">District State: </label>
      </div> -->
      <div>
        <label for="userFirstName">First Name: </label>
        <input type="text" id="userFirstName" v-model="userFirstName">
      </div>
      <div>
        <label for="userLastName">Last Name: </label>
        <input type="text" id="userLastName" v-model="userLastName">
      </div>
      <div>
        <label for="userEmail">Email Address: </label>
        <input type="email" id="userEmail" v-model="userEmail" disabled>
      </div>
      <div>
        <label for="userRole" id="userRole">Role: </label>
        <select v-model="userRole">
          <option disabled value="">Please select one</option>
          <option value="admin">CCS Admin</option>
          <option value="teacher">District Teacher</option>
          <option value="teacher">CCS Trainer</option>
        </select>
      </div>
      <div>
        <label for="active">Active: </label>
        <input type="checkbox" v-model="active">
      </div>
      <div>
        <label for="notes">Notes: </label>
        <textarea id="notes" v-model="notes" rows="4" cols="50" />
      </div>
    </div>
    <button type="button" @click.prevent="updateUserToManage">Update User</button>
    <button type="button" @click.prevent="cancel">Cancel</button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
const fb = require('./../../firebase/firebase')

export default {
  data() {
    return {
      districtCode: '',
      userFirstName: '',
      userLastName: '',
      userEmail: '',
      userRole: '',
      notes: '',
      active: null
    }
  },
  computed: {
    ...mapState([ 'districtId', 'userToManage' ])
  },
  methods: {
    fetchUserCode() {
      fb.userCodesCollection.where("status", "==", 'available').limit(1).get().then((snap) => {
        snap.forEach((doc) => {
          // console.log(doc.id)
          this.userCode = doc.id
        })
      }).then(() => {
        fb.userCodesCollection.doc(this.userCode).update({
          status: 'hold',
          statusUpdated: new Date()
        })
      }).catch((err) => {
        console.log('Error getting code: ', err)
      })
    },
    // addNewUser() {
    //   fb.usersCollection.add({
    //     districtCode: this.districtCode,
    //     userFirstName: this.userFirstName,
    //     userLastName: this.userLastName,
    //     userEmail: this.userEmail,
    //     userRole: this.userRole,
    //     verified: this.verified,
    //     active: this.active,
    //     districtId: this.districtId
    //   }).then(() => {
    //     this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'manageUsers')
    //   }).catch((err) => {
    //     console.log('error creating user: ', err)
    //   })
    // },
    fetchUserToManage() {
      fb.usersCollection.doc(this.userToManage).get().then((doc) => {
        if (doc.exists) {
          // console.log('User Info: ', doc.data())
          this.districtCode = doc.data().districtCode
          this.userFirstName = doc.data().userFirstName
          this.userLastName = doc.data().userLastName
          this.userEmail = doc.data().userEmail
          this.userRole = doc.data().userRole
          this.notes = doc.data().notes || ''
          this.active = doc.data().active
        }
      })
    },
    updateUserToManage() {
      fb.usersCollection.doc(this.userToManage).update({
        userFirstName: this.userFirstName,
        userLastName: this.userLastName,
        userRole: this.userRole,
        notes: this.notes,
        active: this.active
      }).then(() => {
        this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'manageUsers')
        this.$store.commit('SET_USER_TO_MANAGE', null)
      })
    },
    cancel() {
      this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'manageUsers')
      this.$store.commit('SET_USER_TO_MANAGE', null)
    }
  },
  mounted() {
    this.fetchUserToManage()
  }
}
</script>

<style lang="css" scoped>
</style>
